import React, {Component} from 'react';
// import TextField from 'material-ui/TextField';
import {InputText} from '../../blocks/inputs/InputText';
import _ from 'lodash';
import {withRouter} from 'react-router-dom';
import HttpClient from 'services/HttpClient';
import {inject} from 'mobx-react';
import forgotPass from 'images/forgotPass.png';

const RECOVERY_TOKEN_CREATE = '/api/v1/passwords_recovery';

@withRouter
@inject('alertStore')
export default class ResetFormEmail extends Component {
  state = {
    errors  : {},
    formData: {
      email: ''
    }
  };

  handleChange = e => {
    let newState = _.assign({}, this.state.formData, {[e.target.name]: e.target.value});
    this.setState({formData: newState});
  };

  handleSubmit = e => {
    e.preventDefault();
    new HttpClient().post(RECOVERY_TOKEN_CREATE, this.state.formData).then(() => {
      this.handleResponse();
    }).catch(() => {
      this.handleError();
    })
  };

  handleResponse = () => {
    this.props.alertStore.success('Check your email');
    this.props.history.push(`/emailsent/${this.state.formData.email}`);
  };

  handleError = () => {
    const error = 'The email address you entered has not been registered';
    this.props.alertStore.success(error);
    this.setState({formData: {email: ''}})
  };

  render() {

    return (
      <div className="new-form-wrapper">
        <img src={forgotPass} />
        <form className="sign-in-form forgot-password-form" onSubmit={this.handleSubmit}>
          <h2>Forgot Password</h2>
          <span>Enter your email. We will send you a link to change your password.</span>
          <div className="input-wrap">
            <InputText
              name="email"
              className='email'
              label="Email"
              placeholder='Enter Email'
              type="email"
              value={this.state.formData.email}
              onChange={this.handleChange}
            />
          </div>

          <div className="button-set">
            <button className="btn-new-main" style={{width: '100%'}} type="submit">Send</button>
          </div>
        </form>
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/modules/auth/containers/ResetFormEmail.js